export default {"src":"/_next/static/media/checkmarkInactive.cfa1e603.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};